let LOGGER_ENV: string | undefined;

export const setLoggerEnv = (value: string | undefined): void => {
	LOGGER_ENV = value;
};

export const logger = (
	name: string,
	args?: (string | undefined | number)[]
): void => {
	if (LOGGER_ENV === 'production') return;

	const timestamp = formatTime();

	// eslint-disable-next-line no-console
	console.debug(`--- [${timestamp}] ${name}:`, ...(args ?? []));
};

function formatTime(): string {
	const now = new Date();
	const hours = String(now.getHours()).padStart(2, '0');
	const minutes = String(now.getMinutes()).padStart(2, '0');
	const seconds = String(now.getSeconds()).padStart(2, '0');
	const ms = String(now.getMilliseconds()).padStart(3, '0');

	return `${hours}:${minutes}:${seconds}.${ms}`;
}
